const API = `${window.location.origin}/api`;

export const proxyImg = (url, width = 800) => {
  if (!url) return url;
  // Already a relative/same-origin URL
  if (url.startsWith('/') || url.startsWith(window.location.origin)) return url;
  // For Unsplash URLs, request a smaller size directly
  if (url.includes('unsplash.com')) {
    const separator = url.includes('?') ? '&' : '?';
    url = `${url}${separator}w=${width}&q=75&fm=jpg`;
  }
  // External URL — proxy through our backend
  return `${API}/img-proxy?url=${encodeURIComponent(url)}`;
};
